var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 15.185C1.82449 15.8933 2.14199 16.6667 2.96866 16.6667C4.40199 16.6667 4.75949 15.185 5.83366 10C6.90783 4.81499 7.26616 3.33333 8.69866 3.33333C9.52616 3.33333 9.84283 4.10666 10.0003 4.81499M4.09783 8.14833H8.69783M17.5003 10C18.6503 12.7108 18.5712 14.15 17.5003 16.6667M10.0003 10C8.85033 12.7108 8.92949 14.15 10.0003 16.6667M11.9087 11.6667C12.5778 11.6417 12.9603 11.72 13.1862 12.1217C13.4595 12.68 14.1495 14.2233 14.3195 14.56C14.4228 14.7075 14.5595 14.92 15.0003 14.9892L15.592 15",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8366 11.6667C14.8999 11.6667 14.2399 12.74 13.7999 13.28C13.1599 14.12 12.4399 15.0417 11.6641 15",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunction);
export default __webpack_public_path__ + "static/media/function.6dc9b77f3b0f686aa7754c9d806cc508.svg";
export { ForwardRef as ReactComponent };